export const namespace = 'railSetMeal';

export const LANGUAGE_MAP = {
  'zh-cn': {
    高铁列车餐食: '高铁列车餐食',
    请输入车次进行进行查询: '请输入车次进行进行查询',
    车次: '车次',
    始发站: '始发站',
    终点站: '终点站',
    取消: '取消',
    '当前搜索车次暂未提供服务，敬请期待': '当前搜索车次暂未提供服务，敬请期待',
    使用流程: '使用流程',
    套餐内容: '套餐内容',
    服务须知: '服务须知',
  },
  en: {
    高铁列车餐食: 'Rail Set Meal',
    请输入车次进行进行查询: 'Please Enter The Train Number For Query',
    车次: 'Train Number',
    始发站: 'Originating Station',
    终点站: 'Terminal',
    取消: 'Cancel',
    '当前搜索车次暂未提供服务，敬请期待': 'The current search trips do not provide services, so stay tuned',
    使用流程: 'Use Process',
    套餐内容: 'Package Content',
    服务须知: 'Service Notice',
  },
};
